/* global W, window */
import 'es6-object-assign/auto';
import Promise from 'promise-polyfill';
window.Promise = window.Promise || Promise;
import 'whatwg-fetch';
import * as bi from './bi';
import {sanitizeRootNodes, throttle, warnAndReturn, warnAndThen} from './utils';
import {sanitize, obtainFromDOM, useMobileVersion, defaultProfileImage} from './config';
import {domains} from './data/constants.json';
import render from './render';

const acceptJSONHeaders = new Headers({Accept: 'application/json'});

const fetchI18N = config =>
  fetch(`${config.baseUrl}assets/locale/messages/messages_${config.language}.json`)
    .then(response => response.json())
    .catch(warnAndReturn('Error getting i18n files', null));

const fetchUserDetails = () =>
  fetch(window.__DEBUG__ ? `/userDetails` : `//${domains.wix}/_api/wix-html-login-webapp/user/getUserDetails`,
  {headers: acceptJSONHeaders, credentials: 'include'})
    .then(response => response.json())
    .then(response => response.success && response.errorCode === 0 ? response.payload : null)
    .catch(warnAndReturn('Error getting user details', null));

const fetchProfileImage = config =>
  fetch(window.__DEBUG__ ? `/userImage` : `//${domains.wix}/_api/account-info-server/profileimage`,
  {headers: acceptJSONHeaders, credentials: 'include'})
    .then(response => response.json())
    .then(response => response.profileImage || defaultProfileImage(config))
    .catch(warnAndReturn('Error getting profile image, set to default', defaultProfileImage(config)));

let inited = false;

export default function init(config, nodes = {}) {
  if (inited) {
    return warnAndThen('Header and footer is already embedded, don\'t do it twice');
  } inited = true;

  config = sanitize(config);

  const tasks = document.cookie.indexOf('wixClient') >= 0 ?
    [fetchI18N(config), fetchUserDetails(config), fetchProfileImage(config)] :
    [fetchI18N(config)];

  return Promise.all(tasks).then(([translations, user, profileImage]) => {
    if (!translations) {
      return warnAndThen();
    }

    if (user) {
      user.profileImage = profileImage;
    }

    sanitizeRootNodes(nodes);

    let isMobile = useMobileVersion(config);

    window.addEventListener('resize', throttle(() => {
      if (isMobile !== useMobileVersion(config)) {
        isMobile = useMobileVersion(config);
        render(nodes, config, translations, user);
      }
    }, 200));
    render(nodes, config, translations, user);

    bi.desktop.log({evid: 500, is_mobile: isMobile, component: 'header'}); // eslint-disable-line
  })
  .catch(e =>
    warnAndThen('Error embedding header and footer', e)
  );
}

// export API to global W if it is defined
// useful for old grunt-based FE stack
if (W && W.Site && W.Site.Common) {
  W.Site.Common.marketingHeaderAndFooter = {
    init, obtainConfigFromDOM: obtainFromDOM
  };
}



// WEBPACK FOOTER //
// ./app.js